<mat-dialog-content class="customer-dialog">

  <!-- Header -->
  <div class="dialog-header"><i class="fa fa-search" aria-hidden="true"></i>
    {{ 'Customers Search' | translate }}
  </div>

  <!-- Search Section -->
  <div class="search-container">
    <mat-form-field >
      <mat-label>Patient Name</mat-label>
      <input matInput [(ngModel)]="patientFName" (keyup)="retrivePatients()">
    </mat-form-field>

    <mat-form-field  >
      <mat-label>{{'Patient Code' | translate}}</mat-label>
      <input matInput [(ngModel)]="patientCode" (keyup)="retrivePatients()">
    </mat-form-field>

    <mat-form-field >
      <mat-label>{{'Mobile No' | translate}}</mat-label>
      <input matInput [(ngModel)]="telMobile" (keyup)="retrivePatients()">
    </mat-form-field>
  </div>

  <!-- Table -->
  <div class="table-container">
    <table class="customer-table">
      <thead>
        <tr matTooltip="Click for sorting" style="cursor: ns-resize;">
          <th >{{'Code' | translate}}</th>
          <th >{{'Name' | translate}}</th>
          <th >{{'Mobile' | translate}}</th>
          <th>{{'Choose' | translate}} </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sup of CustomerList">
          <td>{{sup.patientCode}}</td>
          <td>{{sup.patientFName}}</td>
          <td>{{sup.telMobile}}</td>
          <td>
            <button mat-raised-button style="color: white;background-color: rgb(0, 0, 128);"
                    (click)="SelectPatient(sup)">
              {{'Select' | translate}}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</mat-dialog-content>
